const PREEXEC_COMMAND_NAME = "phenoscale-pre-exec";
const POSTEXEC_COMMAND_NAME = "phenoscale-post-exec";

export function generateCommand(specs, module) {
    if (!["pre", "post"].includes(module))
        throw new Error('module must be either "pre" or "post"');

    const specsString = `"${JSON.stringify(specs).replaceAll('"', '\\"')}"`;
    const hccProfileOption = "--hcc-profile hcc";

    const execCommand = `${module === "pre" ? PREEXEC_COMMAND_NAME : POSTEXEC_COMMAND_NAME} ${specsString} ${hccProfileOption}`;

    const envActivationCommand = "workon phenoscale";

    return `${envActivationCommand} && ${execCommand}`;
}
